export default {
	termsAndConditions: {
		lastUpdate: 'Sist oppdatert: 10. juni 2024',
		content: `
		<p>Vilkårene du finner nedenfor er viktige fordi:</p>
		<ul>
			<li>De etablerer sine juridiske rettigheter i {siteName}.</li>
			<li>Forklar rettighetene du gir oss når du bruker {siteName}.</li>
			<li>
				De beskriver reglene som alle må respektere når de bruker {siteName}.
			</li>
		</ul>
		<p>
			Vennligst les disse vilkårene nøye, så vel som vår {privacyPolicyLink} og eventuelle andre
			dokumenter nevnt i disse vilkårene.
		</p>
		<p>La oss komme i gang...</p>
		<h3>1. INTRODUKSJON OG DATA OM {siteNameUpper}.</h3>
		<p>
			Nettstedet {websiteLink} (heretter "nettstedet") eies av selskapet
			{siteName} S.L (heretter «{siteName}»), et selskap
			innlemmet i samsvar med spansk lovgivning med adresse på Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Barcelona), innehaver av CIF-nummer
			B-56.768.260 og registrert i Mercantile Registry of Barcelona i volum
			49065, Folio 0033, Blad B-606324, 1. registrering.
		</p>
		<p>
			{siteName} stiller nettstedet til din disposisjon slik at du kan komme til
			kjenn oss bedre, kjenn tjenestene vi leverer og hvis du ønsker det kan du kontakte
			og, der det er hensiktsmessig, kontrakt med oss.
		</p>
		<h3>2. FORMÅL OG ANVENDELSESOMRÅDE FOR BRUKERVILKÅRENE</h3>
		<p>
			Disse bruksvilkårene utgjør sammen med {privacyPolicyLink} og
			{cookiesPolicyLink}, det juridiske rammeverket som regulerer bruken av nettstedet
			{websiteLink}. Disse bruksvilkårene vil være tilgjengelige for deg på nettstedet
			på engelsk slik at du kan konsultere, arkivere eller skrive ut dem når som helst og
			når som helst.
		</p>
		<p>
			For å vite spørsmål angående behandlingen utført av {siteName}.
			av dine personlige data, vennligst besøk vår {privacyPolicyLink} og vår {cookiesPolicyLink}.
			Begge retningslinjene vil også være tilgjengelige for deg på engelsk, slik at du kan
			konsultere, arkivere eller skrive ut dem når som helst.<br />
			{siteName} bruker tredjeparts informasjonskapsler på nettstedet. For å finne ut mer
			om typen informasjonskapsler som brukes på nettet {websiteLink}, deres formål og hvordan
			for å konfigurere nettleseren din i tilfelle du ikke vil at vi skal bruke disse informasjonskapslene,
			vennligst besøk vår {cookiesPolicyLink}.
		</p>
		<p>
			Begge disse bruksvilkårene, så vel som {privacyPolicyLink} og 
			{cookiesPolicyLink} er utarbeidet i samsvar med bestemmelsene i gjeldende
			gjeldende forskrifter, blant annet lov 34/2002, om tjenester til
			Informasjonssamfunnet og elektronisk handel og forordning (EU) 2016/679 av
			Europaparlamentet og rådet av 27. april 2016 angående
			beskyttelse av fysiske personer med hensyn til behandling av personlige
			data og den frie sirkulasjonen av disse dataene og etter hvilke direktiv 95/46 / CE
			er opphevet.
		</p>
		<h3>3. TILGANG TIL NETTSIDEN OG GODKJENNING</h3>
		<p>
			Tilgang til nettstedet er gratis bortsett fra den delen som er relatert til kostnadene for
			tilkobling gjennom telekommunikasjonsnettverket levert av Internett
			tilgangsleverandør som du har avtalt. Du kan fritt bla gjennom nettstedet
			og få tilgang til den så mange ganger du vil. For å få tilgang til og navigere på nettstedet,
			du trenger ikke registrere deg, bortsett fra hvis du ønsker å leie en tjeneste.
		</p>
		<p>
			Bruken av nettstedet gir deg tilstanden til bruker av nettstedet
			(heretter "Brukeren") og innebærer din fulle og uforbeholdne aksept av
			disse bruksvilkårene, samt {privacyPolicyLink} og {cookiesPolicyLink}
			av nettstedet. Videre godtar du å ikke bruke tjenesten for ulovlig
			formål.
		</p>
		<p>
			Ved å gå inn på nettstedet og surfe på det, erklærer du under din
			ansvar for at du er myndig og at du har de nødvendige juridiske
			kapasitet til å få tilgang til nettstedet og bruke det, også erklære at du fullt ut
			forstå og godta disse bruksvilkårene uten forbehold.
		</p>
		<p>
			På den annen side informerer vi deg om at vi av juridiske årsaker arkiverer
			elektroniske dokumenter der kjøpene er formalisert. Du kan få tilgang
			disse dokumentene når som helst ved å be om dem på: {supportLink}.
		</p>
		<h3>4. BETINGELSER FOR BRUK AV NETTSIDEN</h3>
		<p>
			Brukeren godtar å bruke nettstedet i samsvar med disse bruksvilkårene,
			gjeldende lovgivning og god tro. Dermed vil brukeren svare på {siteName}.
			 og overfor enhver tredjepart for skader og tap som følge av
			bruken i strid med disse vilkårene, lovgivningen og den gode tro som er gjort
			av brukeren av nettstedet.
		</p>
		<h3>5. BESKRIVELSE AV TJENESTEN</h3>
		<p>
			Gjennom tjenesten tillater {siteName} abonnement på tjenesten
			utføre bilderedigering.
		</p>
		<p>
			Språket som kontrakten mellom {siteName} og kjøperen på
			vil bli konkludert vil være opprinnelseslandet.<br />
			Kjøpsprosessen i nettjenesten vil være som følger:
		</p>
		<ol>
			<li>Du må registrere deg på nettstedet med brukernavn og passord.</li>
			<li>
				Ved registreringstidspunktet må brukeren velge en av betalingsplanene
				finnes i Priser-delen og vil bli tildelt kreditter avhengig av
				valgt plan. Hver kreditt vil tillate deg å redigere ett bilde.
			</li>
			<li>
				Etter kjøp av tjenesten vil brukeren ha en administrasjon
				panel hvor de finner:
				<ul>
					<li>
						En seksjon med en liste over alle bildene som har blitt behandlet
						kan redigere den så mange ganger du vil og laste den ned til din
						enhet.
					</li>
					<li>
						En del av Planer og betalinger for å konsultere fakturaene og kansellere
						abonnement.
					</li>
					<li>En del av Min konto for å kunne endre kontopreferanser.</li>
				</ul>
			</li>
		</ol>
		<p>
			Når kjøpet av tjenesten er foretatt, vil det bli bekreftet av
			sende en e-post, innen maksimalt 24 timer, til adressen du har
			angitt. Det vil indikere tjenesten, hvordan du kansellerer abonnementet, dens
			beløp, gjeldende avgifter, betalingsmåten og gjeldende vilkår og
			forhold.
		</p>
		<h4>5.1 Abonnement</h4>
		<p>
			Tjenesteabonnementet varierer avhengig av valgt plan og vil være det
			automatisk fornyet for samme tidsperiode frem til oppsigelsen.
			Med mindre du kansellerer abonnementet, gir du oss fullmakt til å laste inn
			tilsvarende årlig abonnementsavgift i betalingsmåten din.
		</p>
		<p>
			Du kan når som helst kansellere abonnementet på tjenesten, og du vil
			fortsett å ha tilgang til den til slutten av den årlige faktureringsperioden. Til
			i den utstrekning loven tillater, er betalinger ikke-refunderbare og vi gir ikke
			refusjoner eller kreditter for delvise årlige abonnementsperioder.
		</p>
		<h3>6. PRIS OG AVGIFT</h3>
		<p>
			Prisene på produktene som tilbys på {siteName} er angitt i euro
			(€) eller valutaen til landet der kjøpet er gjort, verdien
			Tilleggsavgift (MVA) som er gjeldende på kjøpstidspunktet pålegges prisen på
			Produkter.
		</p>
		<p>
			Driften vil uansett kunne være fritatt eller ikke momspliktig avhengig av
			bostedslandet ditt eller tilstanden du handler i. Av denne grunn,
			i noen tilfeller kan den endelige prisen på bestillingen bli endret i forhold til
			en vist.<br />
			Kjøp gjort av subjekter fritatt for momsbetaling vil indikere dette innen
			sende MVA/NIF-nummeret deres på e-post til {supportLink}, uten registrering
			kjøp med nevnte avgift.
		</p>
		<h3>7. BETALINGSMÅTE</h3>
		<p>
			Online betaling av den kjøpte tjenesten kan gjøres med kreditt- eller debetkort.
			I denne forstand informerer {siteName} kreditt- og debetkortinnehavere om dette
			transaksjoner i nettbutikken utføres gjennom en sikker betaling
			gateway, som bruker SSL-teknologi for å garantere sikkerheten for dataoverføring.
		</p>
		<h3>8. ANGRERETT OG REFUSJON</h3>
		<h4>8.1. Angrerett</h4>
		<p>
			Gitt typen produkt som markedsføres i vår online-tjeneste, programvare i digital
			format av QR, vil angreretten ikke gjelde iht
			artikkel 103 bokstav m) i kgl. lovresolusjon 1/2007 av 16. november av
			den at den reviderte teksten til den generelle loven for forbrukernes forsvar og
			Brukere og andre utfyllende lover er godkjent.
		</p>
		<h4>8.2. Refusjoner</h4>
		<p>
			Uavhengig av planen valgt av brukeren, beløpene betalt av brukeren og til
			den utstrekning loven tillater vil ikke bli refundert.
		</p>
		<p>
			Den avtalte tjenesten kan ikke tildeles eller overføres til andre brukere av
			tjenesten.
		</p>
		<p>
			I alle fall kan brukeren benytte seg av den avtalte tjenesten frem til slutten av
			den avtalte perioden.
		</p>
		<h3>9. GYLDIGHET AV TILBUD</h3>
		<p>
			Tjenestene som tilbys i Tjenesten, og deres priser, vil være tilgjengelig for
			kjøpe mens de er i katalogen over tjenester som vises gjennom denne
			nettsted.
		</p>
		<p>
			Uansett forbeholder {siteName} seg retten til å gjøre endringene
			finner det hensiktsmessig i tjenesten, for å kunne oppdatere produkter og tjenester
			avhengig av markedet.
		</p>
		<p>
			{siteName} forbeholder seg retten til å endre priser uten forvarsel. Vi
			informere deg om at til tross for oppdateringene som er gjort til prisene på
			Service, de kan inneholde feil. Vi vil umiddelbart korrigere eventuelle feil som
			vises, men de vil ikke være bindende for tjenesten.
		</p>
		<h3>10. SIKKERHET</h3>
		<p>
			Som angitt ovenfor, hele kjøpsprosedyren, samt overføringen
			av dine personopplysninger og betalingssystemer, utføres på en sikker side og
			på en kryptert måte gjennom SSL-protokollen.
		</p>
		<p>
			Vi garanterer sikkerheten til Tjenesten i samsvar med gjeldende
			teknologisk kunnskap. {siteName} kan imidlertid ikke garantere hele
			fremtidig sikkerhet for tjenesten. Uansett lover vi å korrigere og
			implementere passende korrigerende tiltak for å korrigere en mulig sikkerhet
			brudd så snart som mulig.
		</p>
		<p>
			Du godtar å varsle {siteName} umiddelbart og via e-post {supportLink}
			av enhver situasjon som kan føre til etterligning av en brukers identitet.
		</p>
		<h3>11. ENDRINGER OG NULLITET</h3>
		<p>
			Vi kan også oppdatere vilkårene og betingelsene for tjenesten i fremtiden
			som funksjonene og funksjonene til selve tjenesten.
		</p>
		<p>
			Vi vil informere deg om endringene i vilkår og betingelser ved å legge inn et varsel
			på en fremtredende plass på vår nettside og/eller via e-post.
		</p>
		<p>
			Hvis noen klausul inkludert i disse vilkårene og betingelsene er erklært, helt eller
			delvis, null eller ineffektiv, vil det bare påvirke nevnte bestemmelse eller delen
			av den som er null eller ineffektiv. Vilkårene vil gjelde i
			alt annet, å ha en slik bestemmelse, eller den delen av den som er berørt, av
			ikke blir plassert.
		</p>
		<h3>12. KRAV OG HANDLINGER AVLEDT FRA KONTRAKTEN</h3>
		<p>
			Så langt det er mulig, er denne tjenesten underlagt spansk lov.<br />
			For å forenkle avgjørelsen av krav gjennom sivile rettergang og
			redusere kostnadene, utelukker vi ikke muligheten for å underkaste oss en
			Egenkapitalvoldgift ved voldgiftsretten til handelskamrene og
			Industri. I denne forstand, og i henhold til gjeldende regelverk,
			 {siteName} informerer om eksistensen av en europeisk nettbasert tvisteløsning
			plattform som legger til rette for utenrettslig løsning av slike tvister for
			kontrakter også inngått online mellom forbrukere og Internett-tjenesten
			tilbydere. Denne plattformen kan nås via følgende nettside:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. IMMATERIELLE OG INDUSTRIELLE EIENDOMSRETTER</h3>
		<p>
			Nettstedet og dets innhold er underlagt beskyttelse i henhold til
			gjeldende nasjonale forskrifter om intellektuell og/eller industriell eiendom, som
			samt i anvendelse av de internasjonale konvensjonene som gjelder i slike
			saker. {siteName} er eieren eller har behørig lisensiert alle
			Immaterielle og industrielle rettigheter på nettstedet og dets innhold.
		</p>
		<p>
			Enhver form for reproduksjon, distribusjon, offentlig kommunikasjon, transformasjon,
			tilgjengeliggjøring og, generelt, enhver annen utnyttelseshandling enten det er
			for kommersielle formål på nettstedet eller dets innhold, uten forutgående
			uttrykkelig samtykke fra {siteName}. Det er uttrykkelig forbudt å slette
			identifisere data til {siteName} som eieren av den intellektuelle og
			Industrielle eiendomsrettigheter til nettstedet eller dets innhold.
		</p>
		<p>
			{siteName} forbeholder seg alle intellektuelle og industrielle rettigheter
			over nettstedet og dets innhold, også forbeholder seg utøvelsen av enhver juridisk
			handlinger som tilsvarer det for å stanse, forhindre eller straffeforfølge evt
			ulovlig bruk av nettstedet eller dets innhold. I intet tilfelle og under nr
			omstendighetene gjør tilgang til nettstedet eller dets bruk av brukeren eller tredjepart
			parter utgjør eller antyder en oppdragelse av noe slag fra {siteName} av
			de intellektuelle eller industrielle eiendomsrettighetene til nettstedet eller dets innhold.
			Ikke i noe tilfelle mangel på krav fra {siteName} om å slutte å bruke
			Nettstedet eller dets ulovlige eller innhold som er i strid med disse betingelsene kan være
			forstått som et stilltiende samtykke fra {siteName} til slik bruk eller som en fraskrivelse
			utøvelse av rettslige skritt som kan tilsvare det.
		</p>
		<h3>14. ANSVAR OG GARANTIER</h3>
		<p>
			Brukeren må bruke nettstedet og dets innhold i samsvar med
			bestemmelser i disse bruksvilkårene, gjeldende lovgivning og god tro. Noen
			bruk av nettstedet eller dets innhold i strid med disse generelle vilkårene
			lov eller god tro er uttrykkelig forbudt, uavhengig av om nevnte bruk har
			et økonomisk formål eller ikke.<br />
			Brukeren vil være ansvarlig for enhver skade eller skade forårsaket av {siteName}
			 eller til tredjeparter avledet direkte eller indirekte fra enhver bruk
			som brukeren gjør av nettstedet eller dets innhold i strid med disse
			forhold, loven, moral, offentlig orden eller god tro.
		</p>
		<p>
			For at nettstedet og dets innhold skal være tilgjengelig for brukeren, {siteName}
			 krever tjenester levert av tredjeparter. Er det mulig at
			til tross for innsatsen fra {siteName} for å holde nettstedet tilgjengelig
			og tilgjengelig for brukere, kan tilgjengeligheten bli suspendert, avbrutt eller
			kansellert av årsaker utover {siteName}. Det er derfor {siteName}
			garanterer ikke fravær av avbrudd eller feil ved tilgang til
			Nettstedet eller dets innhold, og heller ikke at de er oppdatert eller alltid vises i
			deres nyeste versjon. Følgelig avviser {siteName} noen
			ansvar for skader som kan utledes til brukeren eller tredjeparter som
			et resultat av suspensjonen, avbrudd, mangel på kontinuitet, nettverksbrudd
			eller frakobling av nettstedet.
		</p>
		<p>
			I intet tilfelle og under ingen omstendigheter vil {siteName} være ansvarlig for
			skader eller tap forårsaket av brukeren fra årsaker som ikke kan tilskrives {siteName}
			 slik som, som eksempel og ikke i noe tilfelle begrensende, naturlig
			katastrofer, situasjoner med force majeure eller ekstremt haster, virus, skadelige
			komponenter, nettleserfeil, nettverksfall, datamaskininnbrudd eller
			tredjepartsangrep.
		</p>
		<h3>15. LENKER</h3>
		<p>
			Nettstedene, plattformene, fora, chatter, blogger eller eksterne sosiale nettverk som
			lenke eller lenke til nettstedet må tydelig informere om at de ikke har
			autorisasjon eller tilsyn med {siteName} og den nevnte koblingen eller
			koblingen innebærer ikke, antar eller antyder tilknytning av noe slag mellom {siteName}
			 og nettsteder, plattformer, fora, chatter, blogger eller eksterne
			sosiale nettverk som lenker eller lenker til nettstedet.
		</p>
		<p>
			I alle fall må enhver lenke som er beregnet på nettstedet være rettet
			direkte til hjemmesiden eller hjemmesiden til nettstedet ved å klikke på URL-en
			av nettstedet som dekker hele skjermen på startsiden eller siden for starten av
			nettstedet, slik at lenken er absolutt og komplett uten bruk av
			rammer, rammer eller hyperkoblinger. {siteName} svarer ikke i noen tilfeller
			og under alle omstendigheter til innholdet, informasjonen eller dataene knyttet til
			nettstedet, dets innhold eller andre forhold som finnes på nettsidene, plattformene,
			fora, chatter, blogger eller tredjeparts sosiale nettverk som lenker eller lenker til
			Nettsted.
		</p>
		<p>
			Det er uttrykkelig forbudt å lenke eller lenke til nettsiden fra nettsider,
			plattformer, fora, chatter, blogger eller sosiale nettverk i strid med loven, moral
			og gode skikker, spesielt de med pornografisk, ulovlig, ulovlig eller
			krenke menneskerettighetsinnhold.
		</p>
		<p>
			På den annen side kan nettstedet inneholde lenker til tredjeparts nettsteder,
			plattformer, fora, chatter, blogger eller sosiale nettverk. {siteName} gjør det ikke
			ha menneskelige og/eller tekniske midler til å kjenne til eller kontrollere informasjonen og
			innhold som vises på tredjeparts nettsteder. Derfor vil {siteName} ikke i noe tilfelle
			 være ansvarlig for innholdet på de koblede sidene og under nr
			omstendigheter kan nevnte lenker betraktes som effektiv kunnskap om innholdet
			av nettstedene de lenker til.
		</p>
		<h3>16. DATABESKYTTELSE</h3>
		<p>
			Som etablert i sin {privacyPolicyLink}, forplikter {siteName} seg til å bruke brukeren
			data, for å respektere dens konfidensialitet og å bruke den i samsvar med
			formålet med behandlingen, samt å overholde sin forpliktelse til å lagre den.
			og tilpasse alle tiltak for å unngå endring, tap, behandling eller uautorisert
			tilgang i samsvar med bestemmelsene i gjeldende lovgivning vedr
			beskyttelse av personopplysninger.
		</p>
		<p>
			Nettstedet inneholder passende sikkerhetstiltak og bruker industristandard
			teknologi for å forbedre sikkerheten, integriteten, fullstendigheten, nøyaktigheten og
			beskyttelse av personopplysningene den har samlet inn og har etablert
			rimelige forholdsregler for å beskytte denne informasjonen mot mulig tap eller
			misbruk. Reglene for databeskyttelse og sikkerhet vurderes med jevne mellomrom
			og forbedres når det er nødvendig, og det streber etter å sikre at kun autorisert
			personer kan få tilgang til informasjonen gitt av brukeren.
		</p>
		<p>
			For å lære mer om administrasjonen og behandlingen utført av {siteName}
			 av dataene dine, vennligst les {privacyPolicyLink} og {cookiesPolicyLink}.
		</p>
		<h3>17. VARIGHET OG ENDRING</h3>
		<p>
			Disse bruksvilkårene vil være i kraft så lenge de utsettes for
			brukere, slik at så snart de er helt eller delvis endret eller oppdatert,
			disse betingelsene vil opphøre å være i kraft, som de nye bruksvilkårene
			de som fortsetter å regulere bruken av nettstedet.
		</p>
		<p>
			{siteName} forbeholder seg retten til å gjennomgå, endre eller oppdatere disse
			bruksvilkår til enhver tid. Ved eventuelle endringer i disse betingelsene
			for bruk uansett grunn, vil {siteName} varsle brukerne på hjemmesiden om
			nettet om nevnte forhold slik at de er behørig informert og kan konsultere
			revisjonene, modifikasjonene eller oppdateringene av gjeldende bruksbetingelser til
			din tilfredshet.
		</p>
		<h3>18. GENERELT</h3>
		<p>
			I intet tilfelle og under ingen omstendigheter kan mangel på utøvelse av dine rettigheter
			av {siteName} forstås som en fraskrivelse av dem.
		</p>
		<p>
			Overskriftene i disse betingelsene er kun veiledende eller
			informative, slik at de ikke påvirker, kvalifiserer eller utvider tolkningen
			derav.
		</p>
		<p>
			I tilfelle at noen av klausulene i disse betingelsene var
			erklært ugyldig, fornærmende eller ikke håndhevbar, helt eller delvis, av en rettsinstans
			eller administrativt organ, vil nevnte erklæring påvirke klausulen individuelt
			aktuelle, tar det som ikke og uten ugyldighetserklæring, misbruk eller
			uanvendelighet utvides under noen omstendigheter til resten av
			forhold som vil bestå.
		</p>
		<p>
			Disse bruksvilkårene, samt {privacyPolicyLink} og {cookiesPolicyLink}
			er underlagt gjeldende spanske regler til enhver tid.
		</p>
		<h3>19. KUNDESERVICE</h3>
		<p>
			For enhver avklaring, hendelse eller krav, kan du kontakte oss via:<br />
			E-post: {supportLink}<br />
			Postadresse: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spania.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Sist oppdatert: 10. juni 2024',
		content: `
			<h3>1. Ansvarlig part og beskrivelse</h3>
			<h5>1.1. Ansvarlig</h5>
			<p>Personen som er ansvarlig for behandlingen av dette nettstedet er Remove Background S.L (heretter kalt Remove Background 
			eller tjenesten), med adresse på Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spania.</p>
			<p>NIF: B56768260<br> E-post: {supportLink}</p>

			<h5>1.2. Beskrivelse</h5>
			<p>Aksept av personvernreglene til Remove Background (heretter kalt "Personvernregler"), er en nødvendig betingelse 
				for bruk av nettstedet vårt og levering av tjenesten (heretter kalt "tjenesten").<br>
				Denne personvernerklæringen regulerer innsamling, behandling og bruk av dine personlige og ikke-personlige opplysninger 
				som bruker av Fjern bakgrunn, fra og med ikrafttredelsesdatoen som vises i overskriften.<br>
				For å behandle dine personopplysninger overholder Remove Background gjeldende lokal og europeisk lovgivning, 
				samt dens gjennomføringsforskrifter.</p>


			<h3>2. Informasjon samlet inn</h3>
			<p>Tilgang til nettstedet vårt kan gjøres uten å måtte oppgi informasjon, men for å registrere og / 
				eller avtale våre planer, må du gi oss personlig informasjon. Informasjonen (personlig 
				eller ikke-personlig) som samles inn av tjenesten kan variere basert på det.<br>
				Den personlige og ikke-personlige informasjonen som samles inn av tjenesten vil komme til oss på tre måter: 1) det som 
				samles inn automatisk 2) det du gir oss frivillig og 3) det som er levert av tredjeparter.</p>

			<h5>2.1. Den som samles inn automatisk</h5>
			<p>Denne informasjonen vil bestå av:</p>
			<ul>
				<li>Den som samles inn gjennom informasjonskapsler eller lignende mekanismer lagret på enheten din, alltid med ditt samtykke eller i 
					i samsvar med andre rettslige grunnlag. Se våre retningslinjer for informasjonskapsler for mer informasjon.</li>
				<li>IP-en som tilkoblingen er opprettet fra, typen enhet som brukes og dens egenskaper, versjonen av 
					operativsystemet, typen nettleser, språket, datoen, landet, tidspunktet for forespørselen, 
					URL-en fra den du kommer fra, URL-en du går til eller mobilnettverket som brukes, blant annet.</li>
				<li>Tjenestebruksdata og mulige feil oppdaget under bruken.</li>
				<li>I tillegg bruker Remove Background Google Analytics, en analytisk tjeneste levert av Google, LLC. 
					hjemmehørende i USA med hovedkontor på 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					For å levere disse tjenestene bruker de informasjonskapsler som samler inn informasjon, inkludert brukerens IP-adresse, 
					som vil bli overført, behandlet og lagret av Google i vilkårene fastsatt på nettet www.google.com. 
					Inkludert mulig overføring av nevnte informasjon til tredjeparter på grunn av lovkrav eller 
					når nevnte tredjeparter behandler informasjonen på vegne av Google.</li>
			</ul>
			<p>I alle fall kan du deaktivere Google Analytics-informasjonskapsler fra <a href="{externalLink: disableGoogleAnalyticsLink}">her</a>.</p>

			<h5>2.2. Den du frivillig gir</h5>
			<p>Denne informasjonen vil bestå av:</p>
			<ul>
				<li>Alle data er obligatoriske.</li>
				<li>Den som kreves av Remove Background for å fullføre registreringen på nettet: navn og etternavn, adresse og e-postadresse, blant annet.</li>
				<li>Alle data er obligatoriske.</li>
				<li>Informasjonen, personlig eller ikke, for å fullføre kontrakten for tjenesten, for eksempel e-postadressen din og kreditt- eller debetkortnummeret ditt.</li>
				<li>Informasjonen, personlig eller ikke, som meldingene som sendes gjennom kontakt- eller meningskanalene etablert i tjenesten kan inneholde, 
					for eksempel navn og e-post.</li>
			</ul>

			<h5>2.3. Den som leveres av tredjeparter</h5>
			<p>Denne informasjonen vil bestå av:</p>
			<ul>
				<li>Den som leveres av betalingssystemer eller kredittkortbehandlere, for eksempel kjøpstidspunktet eller beløpet.</li>
			</ul>


			<h3>3. Rettigheter og formål</h3>
			<p>Vi informerer deg om at utfylling av skjemaene er frivillig. Men hvis du ikke fyller ut de obligatoriske feltene 
				(vanligvis merket med en stjerne), vil bruken av enkelte funksjoner i tjenesten ikke være mulig eller begrenset.<br>
				Personopplysningene du gir oss vil bli innlemmet og behandlet i registeret for behandlingsaktiviteter med fjerningsbakgrunn 
				for å kunne ivareta dine forespørsler, yte den forespurte tjenesten og holde deg informert om forhold knyttet til aktiviteten 
				av selskapet og dets tjenester.<br>
				Du kan når som helst utøve rettighetene til tilgang, retting, sletting, begrensning av behandlingen din, 
				motstand og portabilitet av dine personlige data via e-post adressert til: {supportLink} eller postadressen: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spania.<br>
				I begge tilfeller må du identifisere deg med navn og etternavn, samt en kopi av DNI eller nasjonal ID, om nødvendig.<br>
				I tilfelle du har gitt samtykke til et bestemt formål, har du rett til å trekke tilbake samtykket når som helst, 
				uten at det påvirker lovligheten av behandlingen basert på samtykket før det trekkes tilbake.<br>
				I tillegg, hvis du mener at det er et problem med måten Remove Background håndterer dataene dine på, 
				du kan rette klagene dine til <a href="{knowYourRightsLink}">databeskyttelsesmyndigheten</a> som tilsvarer, som er <a href="{aepdLink}">det spanske byrået for databeskyttelse</a> 
				den som er angitt for Spania.</p>


			<h3>4. Alder</h3>
			<p>Når det gjelder bruken av nettjenesten, erklærer du at du er myndig og at du har de nødvendige juridiske 
				kapasitet til å være bundet av denne avtalen og bruke nettstedet i samsvar med dets vilkår og betingelser, som du fullt ut 
				forstå og erkjenne.<br>
				Du erklærer at all informasjonen du gir for å få tilgang til tjenesten, før og under bruken, er sann, fullstendig 
				og nøyaktig.</p>


			<h3>5. Bruk av data</h3>
			<p>Fjern bakgrunn vil bruke de innsamlede dataene til å:</p>
			<ul>
				<li>Administrer og oppdater tjenesten (det juridiske grunnlaget er vår legitime interesse i å opprettholde og beholde tjenesten 
					oppdatert og i god stand).</li>
				<li>Ta opp spørsmålene du reiser (det juridiske grunnlaget er vår legitime interesse i å ivareta forespørslene og 
					tvil fra brukerne våre).</li>
				<li>Behandle betalingene du foretar (kontrakten er det juridiske grunnlaget).</li>
				<li>Levere den avtalte tjenesten (kontrakten er det juridiske grunnlaget).</li>
				<li>Oppretthold sikkerheten til tjenesten, undersøk ulovlige aktiviteter, håndhev våre vilkår og betingelser og
					hjelpe de statlige sikkerhetsstyrkene i forbindelse med deres mulige undersøkelser (det juridiske grunnlaget er vårt 
					legitim interesse i å garantere og opprettholde sikkerheten til tjenesten og dens brukere).</li>
			</ul>
			<p>Fjern bakgrunn bruker ikke automatiserte beslutninger, selv om det kan generere grunnleggende brukerprofiler, 
				det juridiske grunnlaget er vår legitime interesse for kommersielle formål og å gi personlig tilpassede tilbud.<br>
				Fjern bakgrunn kan også bruke brukerinformasjon i form av aggregerte og anonyme data for å vise den til tredjeparter. 
				Du kan også dele statistikk og demografisk informasjon om brukere og deres bruk av tjenesten med tredjeparter. 
				Men ingenting av dette vil tillate disse tredjepartene å identifisere deg personlig.</p>

			<h5>5.1. I e-poster og kontaktskjemaer</h5>
			<p>Nettstedet har en SSL-kryptering som lar brukeren sende sine personlige data sikkert gjennom standard kontaktskjemaer.<br>
				Personopplysningene som samles inn vil bli gjenstand for automatisert behandling og innlemmet i de tilsvarende filene 
				av registreringen av behandlingsaktiviteter og som Remove Background er eier av.</p>
			<p>I den forstand:</p>
			<ul>
				<li>Vi vil motta IP-adressen din, som vil bli brukt til å bekrefte opprinnelsen til meldingen for å kunne tilby deg tilstrekkelig 
					anbefalinger (for eksempel presentere informasjonen på riktig språk) og for å oppdage mulige uregelmessigheter 
					(for eksempel mulige forsøk på nettangrep på tjenesten), samt data relatert til Internett-leverandøren din.</li>
				<li>På samme måte kan du gi oss dataene dine via telefon, e-post og andre angitte kommunikasjonsmidler.</li>
			</ul>
			<p>Angående betalingsmåten som brukes:</p>
			<ul>
				<li>Våre betalingstjenesteleverandører for å betale for leveringen av tjenestene våre er kreditt- eller debetkort. 
					Ikke på noe tidspunkt vil tjenesten eller dens ansatte ha tilgang til bankdetaljene (for eksempel kredittkortnummeret) 
					som brukeren som kunde vil gi til disse tredjepartene.</li>
			</ul>


			<h3>6. Oppbevaring av data</h3>
			<p>Nedenfor er de angitt hvor lenge dataene som behandles av tjenesten oppbevares:</p>
			<ul>
				<li>De disaggregerte dataene vil bli oppbevart uten en sletteperiode.</li>
				<li>
					Kundedata vil bli oppbevart for det minimum som er nødvendig, og kan oppbevares til:
					<ul>
						<li>5 år, i henhold til art. 1964 i Civil Code (personlige handlinger uten spesiell sikt).</li>
						<li>6 år, i henhold til art. 30 i handelsloven (for eksempel regnskapsbøker eller fakturaer).</li>
					</ul>
				</li>
				<li>Brukerdata vil bli oppbevart i maksimalt 12 måneder for å kunne imøtekomme forespørslene deres.</li>
			</ul>


			<h3>7. Data delt med tredjeparter</h3>
			<p>Det er tredjeparter som administrerer deler av tjenesten.<br>
				Fjern bakgrunn krever at de overholder denne personvernreglene som er aktuelt, i tillegg til å ha sine egne. Fjern bakgrunn vil imidlertid ikke være ansvarlig for overholdelse av nevnte retningslinjer.<br>
				Under noen omstendigheter kan Remove Background dele, bruke eller oppbevare noen av personopplysningene som samles inn med tredjeparter:</p>
			<ul>
				<li>Slik leverer du tjenesten:</li>
			</ul>
			<p>Tjenesteleverandører som utfører funksjoner på våre vegne, for eksempel betalingstjenester, webhotell, forretningsanalyse, kundeservice eller nettmarkedsføring. Disse tjenesteleverandørene kan samle inn og ha tilgang til informasjonen som er nødvendig for at de skal kunne utføre sine funksjoner, men de har ikke lov til å dele eller bruke informasjonen til andre formål.</p>
			<ul>
				<li>For å samarbeide med kompetente myndigheter:</li>
			</ul>
			<p>Hvis vi mener det er rimelig nødvendig for å tilfredsstille enhver lov, juridisk prosess eller legitim interesse. I alle fall vil vi bare gi den informasjonen som er strengt nødvendig.</p>


			<h3>8. Sikkerhetstiltak</h3>
			<p>Fjern bakgrunn vedtar alle tekniske og organisatoriske tiltak som er nødvendige for å
				beskytte sikkerheten og integriteten til personlig og ikke-personlig informasjon som samles inn. 
				Både mot uautorisert tilgang og utilsiktet endring, tap eller ødeleggelse.<br>
				Fjern bakgrunn kan uansett ikke garantere den absolutte sikkerheten til informasjonen som samles inn, 
				så du må samarbeide og bruke sunn fornuft om informasjonen som deles til enhver tid.<br>
				Du forstår og erkjenner at, selv etter sletting, kan personlig og ikke-personlig informasjon 
				forbli synlig i hurtigbufferen eller hvis andre brukere har kopiert eller lagret den.</p>


			<h3>9. Endringer i personvernreglene</h3>
			<p>Vi kan oppdatere denne personvernerklæringen i fremtiden. Vi vil informere deg om endringene ved å sende en melding til den oppgitte e-postadressen og/eller ved å plassere en melding på et fremtredende sted på nettstedet vårt.</p>


			<h3>10. Kontakt</h3>
			<p>Hvis du har spørsmål om denne personvernerklæringen, kontakt oss på:</p>
			<p>E-post: {supportLink}<br> 
				Adresse: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spania.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Sist oppdatert: 10. juni 2024',
		content: `
			<h3>1. Hvem er ansvarlig og hvordan kontakter du dem?</h3>
			<p>Kontrolleren for dette nettstedet er Remove Background S.L med adresse på Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spania.</p>
			<p>Du kan kontakte ham via e-post på {supportLink}.</p>

			<h3>2. Hvilke data samles inn?</h3>
			<p>
				Vi samler automatisk inn data gjennom informasjonskapslene som vi laster inn på enheten din, inkludert analyser. 
				Vi samler også inn IP-en som tilkoblingen er laget fra, typen enhet som brukes og dens egenskaper, 
				versjonen av operativsystemet, typen nettleser, språket, datoen, landet, tidspunktet for forespørselen, 
				URL-en du kommer fra, URL-en du går til eller mobilnettverket som brukes, blant annet.<br>
				Frivillig gir brukeren oss noe informasjon som navn og etternavn, e-post eller bankinformasjon 
				for å kunne kontakte oss, melde deg på tjenesten eller kjøpe et abonnement.
			</p>

			<h3>3. Hva brukes de innsamlede dataene til?</h3>
			<p>
				Tjenesten vil bruke dataene som samles inn, blant annet til å administrere og oppdatere tjenesten, svare på dine forespørsler, 
				sende deg vårt nyhetsbrev og kampanjetilbud på e-post, administrer registreringen din på plattformen, administrer og gi 
				tjenestene knyttet til abonnementet ditt, behandle betalingene du foretar og utstede de tilsvarende fakturaene, 
				opprettholde sikkerheten til tjenesten, undersøke ulovlige aktiviteter, håndheve våre vilkår og betingelser og 
				hjelpe de statlige sikkerhetsstyrkene og -organene i forbindelse med deres eventuelle etterforskning.
			</p>

			<h3>4. Hvor lenge oppbevares de?</h3>
			<ul>
				<li>De disaggregerte dataene vil bli oppbevart uten en sletteperiode.</li>
				<li>
					Kundedata vil bli oppbevart for det minimum som er nødvendig, og kan oppbevares til:
					<ul>
						<li>5 år, i henhold til art. 1964 i Civil Code (personlige handlinger uten spesiell sikt).</li>
						<li>6 år, i henhold til art. 30 i handelsloven (for eksempel regnskapsbøker eller faktura).</li>
					</ul>
				</li>
				<li>Brukerdata vil bli oppbevart i maksimalt 12 måneder for å ivareta deres forespørsler.</li>
				<li>Brukerdata lastet opp av tjenesten til sider og profiler på sosiale nettverk vil bli oppbevart fra det øyeblikket brukeren gir sitt samtykke til han trekker det tilbake.</li>
			</ul>

			<h3>5. Hvilke rettigheter har du som bruker?</h3>

			<p>
				Rett til innsyn: Den berørte part skal ha rett til å få bekreftelse fra behandlingsansvarlig om 
				eller ikke personopplysninger om ham eller henne behandles.
			</p>
			<p>
				Rett til retting: den berørte part skal ha rett til å få, uten ugrunnet opphold, fra den behandlingsansvarlige 
				retting av personopplysninger som er unøyaktige og som berører ham direkte. Likeledes vil interessenten 
				har rett til å komplettere ufullstendige personopplysninger, inkludert ved hjelp av en tilleggserklæring.
			</p>
			<p>
				Rett til sletting: Det er den berørte partens rett å uten ugrunnet opphold få slettingen fra behandlingsansvarlig 
				av personopplysningene som angår ham.
			</p>
			<p>
				Retten til å begrense databehandlingen: består i å oppnå begrensning av behandlingen av dataene dine av den ansvarlige, 
				selv om øvelsen har to aspekter: 1) Når du utfordrer nøyaktigheten til dine personlige data, i løpet av en periode som tillater 
				den ansvarlige for å bekrefte det og 2) Når du har protestert mot behandlingen av dine personopplysninger som den ansvarlige 
				utfører ut fra legitim interesse eller et oppdrag av offentlig interesse, mens den ansvarlige kontrollerer om disse grunnene 
				seire over din.
			</p>
			<p>
				Rett til dataportabilitet: Det er den berørte partens rett til å motta personopplysningene som angår ham, 
				som han har gitt til en behandlingsansvarlig, i et strukturert format, av vanlig bruk og mekanisk avlesning, og 
				å overføre dem til en annen kontroller uten å bli forhindret av kontrolløren som de ble levert til.
			</p>
			<p>
				I denne forstand vil den interesserte part ha rett til å få personopplysninger overført direkte fra behandlingsansvarlig 
				til kontrolleren når det er teknisk mulig.
			</p>

			<h3>6. Hvordan kan du utøve rettighetene dine?</h3>

			<p>
				Du kan utøve dine personopplysningsrettigheter når som helst ved å sende en e-post til: {supportLink} Eller postadressen: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spania. I begge tilfeller må du identifisere deg med navn og etternavn, 
				samt en kopi av DNI eller nasjonal ID, om nødvendig.<br>
				I tillegg, hvis du mener at det er et problem med måten Remove Background håndterer dataene dine på, kan du rette dine krav 
				til <a href="{knowYourRightsLink}">databeskyttelsesmyndigheten</a> som tilsvarer, som er <a href="{aepdLink}">det spanske byrået for databeskyttelse</a> 
				den som er angitt i tilfellet Spania.
			</p>

			<h3>7. Vedtas sikkerhetstiltak?</h3>
			<p>
				Tjenesten tar alle nødvendige tekniske og organisatoriske tiltak for å beskytte personvernets sikkerhet og integritet 
				og ikke-personlig informasjon samlet inn. Både mot uautorisert tilgang og utilsiktet endring, tap eller ødeleggelse.<br>
				Tjenesten kan i alle fall ikke garantere den absolutte sikkerheten til informasjonen som samles inn, så du må samarbeide og 
				bruk sunn fornuft til enhver tid angående delt informasjon.<br>
				Du forstår og erkjenner at, selv etter sletting, kan personlig og ikke-personlig informasjon forbli synlig i hurtigbufferen eller 
				hvis den er kopiert eller lagret av andre brukere.
			</p>

			<h3>8. Er det overføringer av personopplysninger eller internasjonale overføringer?</h3>

			<p>
				Vi overfører ikke data eller internasjonale overføringer. Det er imidlertid tredjeparter som administrerer deler av tjenesten 
				at vi krever å overholde våre retningslinjer for personvern i den grad det gjelder dem og at de har sine egne. 
				Disse tredjepartene er tjenesteleverandører som utfører funksjoner på våre vegne, for eksempel webhotell, 
				analyseovervåking eller nettutvikling.<br>
				Også hvis vi mener at det er rimelig nødvendig for å tilfredsstille enhver lov, juridisk prosess eller legitim interesse. 
				Uansett vil vi kun gi den strengt nødvendige informasjonen.
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: 'Sist oppdatert: 21. juni 2024',
		content: `
			<h3>Sammendrag</h3>
			<ul>
			    <li>Informasjonskapsler brukt: <strong>Egen og tredjepart</strong></li>
			    <li>Brukes de til å innhente statistikk? <strong>Ja, basert på vår legitime interesse i å bedre administrere tjenesten.</strong></li>
			    <li>Tredjepartstjenester som installerer informasjonskapsler via dette nettstedet: <strong>Google, Google Analytics, Cloudflare og Stripe.</strong></li>
			</ul>

			<h3>Hvordan konfigurere og deaktivere informasjonskapsler</h3>
			<p>
			    Du kan tillate, blokkere eller slette informasjonskapslene som er installert på enheten din fra nettleseren din. Hvis du ikke tillater at informasjonskapsler installeres på enheten din, 
			    nettleseropplevelsen kan forverres. Nedenfor finner du hvordan du konfigurerer informasjonskapsler i hver nettleser:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Typer og bruksområder</h3>
			<p>Tjenesten bruker egne og tredjeparts informasjonskapsler for å forbedre nettlesingen, tilby tjenesten og få statistikk om bruken av nettstedet.</p>

			<h3>2. Hva er en informasjonskapsel og hva brukes den til?</h3>
			<p>
			    En informasjonskapsel er en tekstfil som sendes til nettleseren din på datamaskin, mobil eller nettbrett og brukes til å lagre og hente informasjon om
			    surfingen er ferdig. For eksempel for å huske brukernavnet og passordet ditt eller profilinnstillingene dine.
			</p>

			<h3>3. Hvilke typer informasjonskapsler finnes?</h3>
			<p>I henhold til hvem som administrerer dem:</p>
			<ul>
			    <li>Egne informasjonskapsler; de sendes til nettleseren din fra vårt eget utstyr eller nettdomener.</li>
			    <li>Tredjeparts informasjonskapsler; de sendes til nettleseren din fra utstyr eller nettdomener som vi ikke administrerer direkte, men av en tredje enhet som Google.</li>
			</ul>
			<p>Basert på hvor lenge de forblir aktive, er det:</p>
			<ul>
			    <li>Øktinformasjonskapsler; de forblir i nettleserens informasjonskapselfil til du forlater nettstedet, så ingen blir på enheten din.</li>
			    <li>Vedvarende informasjonskapsler; de forblir på enheten din, og nettstedet vårt leser dem hver gang du besøker nytt. Disse informasjonskapslene slutter å virke etter en bestemt dato.</li>
			</ul>
			<p>Til slutt, i henhold til formålet deres, har vi:</p>
			<ul>
			    <li>Tekniske informasjonskapsler; de forbedrer nettlesingen og funksjonen til nettstedet.</li>
			    <li>Personlig informasjonskapsler; de gir tilgang til tjenesten med forhåndsdefinerte egenskaper basert på en rekke kriterier.</li>
			    <li>Analytics-informasjonskapsler; de tillater måling og statistisk analyse av bruken av tjenesten som tilbys.</li>
			</ul>
			<p>Liste over tredjeparts informasjonskapsler brukt av <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Informasjonskapslene deres (NID eller SAMTYKKE) gjør det mulig å tilpasse hvordan annonser vises utenfor Google eller lagre informasjon
			        som foretrukket språk ved visning av søkeresultater.<br><a href="{externalLink: googleCookieTypes}">Mer informasjon</a> om hvilke typer informasjonskapsler som Google bruker i sine ulike tjenester.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: Informasjonskapslene deres (som _ga) gjør det mulig å telle hvor mange ganger en bruker besøker et nettsted, hvordan, når og hvorfra.<br>
			        I alle fall kan du deaktivere Google Analytics-informasjonskapsler fra <a href="{externalLink: disableGoogleAnalytics}">her</a>.
			    </li>
			    <li>Cloudflare: For å lære om Cloudflares retningslinjer for informasjonskapsler og bruk, klikk <a href="{externalLink: cloudflareCookiesPolicy}">denne koblingen</a>.</li>
			    <li>Stripe: Finn informasjon <a href="{externalLink: stripeCookiesPolicy}">her</a> om Stripes retningslinjer for informasjonskapsler og bruk.</li>
			</ul>
		`
	}
};
